import { createFileRoute } from "@tanstack/react-router";
import { breedRouteOptions, BreedPage } from "@/features/breeds";

export const Route = createFileRoute("/breed/$breedId")({
    loader: breedRouteOptions.loader,
    pendingComponent: breedRouteOptions.pendingComponent,
    head: breedRouteOptions.head,
    component: BreedPage,
});
